import { schema } from 'normalizr';
import { SCHEMA_TYPE_CREDENTIALS_GROUPS } from '../constants/schemaTypes';
import credentialSchema from './credential';

const credentialsGroupSchema = new schema.Entity(SCHEMA_TYPE_CREDENTIALS_GROUPS, {
  data_credentials: [credentialSchema],
});

export default credentialsGroupSchema;
